import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import MLIcon from '../MLIcon';
import Tooltip from '../LazyWidgets/Tooltip';
import './TitleBar.css';

const TitleBar = ({
  className = '',
  title = null,
  icon = null,
  subTitle = null,
  iconOnClick = null,
  children,
  ...otherProps
}) => {

  const classes = classNames(
    'ng-ui-widgets',
    'ng-ui-title-bar',
    icon ? 'with-icon' : '',
    className,
  );

  const iconClasses = classNames(
    'styled-ml-icon',
    iconOnClick ? 'icon-clickable' : 'icon-default'
  );

  const renderIcon = () => {
    if (icon) {
      return (
        <div className="wrapper-icon" onClick={iconOnClick}>
          <MLIcon
            className={iconClasses}
            title={`icon-${icon}`}
            type={icon}
            width="24"
            height="24"
            scale={1}
            fill="#c8c8c8"
            viewBox="0 0 24 24"
          />
        </div>
      );
    }
    return null;
  };

  return (
    <section className="ng-ui-title-bar-wrapper">
      <div {...otherProps} className={classes}>
        {renderIcon()}
        <section className="wrapper-titles">
          {title && (
            <Tooltip
              className="styled-tooltip"
              id="ng-ui-tooltip"
              trigger={<div className="title">{title}</div>}
              content={title}
              position="bottom center"
              on="click"
            />
          )}
          {subTitle && (
            <Tooltip
              className="styled-tooltip"
              id="ng-ui-tooltip-st"
              trigger={<div className="sub-title">{subTitle}</div>}
              content={subTitle}
              position="bottom center"
              on="click"
            />
          )}
        </section>
        {children}
      </div>
    </section>
  );
};



TitleBar.propTypes = {
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.array,
    PropTypes.object,
  ]),
  icon: PropTypes.string,
  children: PropTypes.node.isRequired,
  iconOnClick: PropTypes.func,
  title: PropTypes.string,
  subTitle: PropTypes.string,
};

export default TitleBar;